export enum CandidateType {
  EXPLICIT = "EXPLICIT",
  OPENING = "OPENING",
  CORNER = "CORNER",
}

export enum ControllerPlacementPass {
  BY_DOOR = "BY_DOOR",
  BY_DOOR_BEHIND_SWING = "BY_DOOR_BEHIND_SWING",
  BY_DOOR_LATCH_SIDE = "BY_DOOR_LATCH_SIDE",
  BY_CORNER = "BY_CORNER",
  EXPLICIT = "EXPLICIT",
}

// forward is counter-clockwise on the inside of the room perimeter
export enum InsertionWindingDirection {
  FORWARD = "FORWARD",
  BACKWARD = "BACKWARD",
  CENTER = "CENTER",
}
